// extracted by mini-css-extract-plugin
export var circle = "_q-2";
export var icon = "_q-a";
export var iconHighlight = "_q-0";
export var lg = "_q-8";
export var md = "_q-7";
export var outline = "_q-4";
export var sm = "_q-6";
export var square = "_q-1";
export var xl = "_q-9";
export var xs = "_q-5";
export var xxs = "_q-3";